import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import * as routes from 'routes';
import { navigate } from 'utils';

interface Props {
	label: string;
}

const CreateDsAction = ({ label }: Props) => {
	const onClick = () => {
		navigate(routes.createDesignSystem());
	};

	return (
		<ActionButton
			icon={IconType.PALETTE}
			label={label}
			onClick={onClick}
		/>
	);
};

export default CreateDsAction;
